export default "__VITE_ASSET__MN3JOh$3__"